export enum AuthActionsEnum {
  SET_USER = 'SET_USER',
  CLEAR_USER = 'CLEAR_USER',
  AUTH_LOGIN = 'AUTH_LOGIN',
  AUTH_SET_ERROR = 'AUTH_SET_ERROR',
  AUTH_INIT_ESIA_AUTH_PROCESS = 'AUTH_INIT_ESIA_AUTH_PROCESS',
  AUTH_SET_STAGE = 'AUTH_SET_STAGE',
  AUTH_SET_ORGANIZATIONS = 'AUTH_SET_ORGANIZATIONS',
  AUTH_LOGOUT = 'AUTH_LOGOUT',
  AUTH_SET_IS_LOGGED_OUT = 'AUTH_SET_IS_LOGGED_OUT',
}
